<template>
	<v-row>
		<v-sheet class="d-flex mt-3" width="100%">
			<!-- 左侧主内容区 -->
			<v-sheet width="100%">
				<v-row dense class="ma-2">
					<v-col cols="3" class="pa-2">
						<v-card>
							<v-card-title>本月缴费</v-card-title>
							<v-card-text>
								<span class="text-h5">{{monthData.rechargeAmount}}</span>
								<span class="ml-1 mr-2">元</span>
							</v-card-text>
							<v-card-actions>
								<span>&nbsp;</span>
							</v-card-actions>
							<!-- <v-divider class="ml-2 mr-2"></v-divider>
							<v-card-actions>
								<span>课时账户:</span>
								<span>{{monthData.rechargeForHour}}元</span>
								<span class="ml-5">金额账户:</span>
								<span>{{monthData.rechargeForTuition}}元</span>
							</v-card-actions> -->
						</v-card>
					</v-col>
					<v-col cols="3" class="pa-2">
						<v-card>
							<v-card-title>本月新入学员</v-card-title>
							<v-card-text>
								<span class="text-h5">{{monthData.newStudentCount}}</span>
								<span class="ml-1 mr-2">人</span>
							</v-card-text>
							<v-divider class="ml-2 mr-2"></v-divider>
							<v-card-actions>
								<span>总在读:{{monthData.inShopCount}}人</span>
							</v-card-actions>
						</v-card>
					</v-col>
					<v-col cols="3" class="pa-2">
						<v-card>
							<v-card-title>本月总消课</v-card-title>
							<v-card-text>
								
								<span class="text-h5">{{monthData.reduceClassHours||0}}</span>
								<span class="ml-1 mr-2">课时</span>
								<!-- <span class="ml-2 mr-1">金额</span>
								<span class="text-h5">{{monthData.reduceTuitionFee}}</span>
								<span class="ml-1 mr-2">元</span> -->
							</v-card-text>
							<v-divider class="ml-2 mr-2"></v-divider>
							<v-card-actions>
								<span>课时模式:{{monthData.reduceTimeHours||0}}</span>
								<template v-if="monthData.reduceCashHours > 0">
									<span class="ml-2">金额模式:{{monthData.reduceCashHours}}</span>
								</template>
							</v-card-actions>
						</v-card>
					</v-col>
					<v-col cols="3" class="pa-2">
						<v-card>
							<v-card-title>本月消课收入</v-card-title>
							<v-card-text>
								<span class="text-h5">{{monthData.recordRevenueAmount}}</span>
								<span class="ml-1 mr-2">元</span>
							</v-card-text>
							<v-card-actions>
								<span>&nbsp;</span>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
				<v-row dense class="ma-2">
					<v-col cols="9" class="pa-2">
						<!-- 常用功能 -->
						<v-card>
							<v-card-title>常用功能</v-card-title>
							<v-card-text class="pb-10">
								<v-row dense>
									
									<v-col cols="4">
										<!-- @click="createStudentShow=true" -->
										<div class="d-flex align-center mt-1" @click="toLink('/edu/student/list')" style="cursor: pointer;">
											<v-avatar rounded class="my-1">
												<v-img src="https://photo.youkeya.cn/assets/icon/add_student_icon.jpeg" width="50" height="50"></v-img>
											</v-avatar>
											<span class="ml-6">新增学员</span>
										</div>
										
										<div class="d-flex align-center mt-5" @click="toLink('/edu/class/list')" style="cursor: pointer;">
											<v-avatar rounded class="my-1">
												<v-img src="https://photo.youkeya.cn/assets/icon/add_class_icon.jpeg" width="50" height="50"></v-img>
											</v-avatar>
											<span class="ml-6">建班排课</span>
										</div>
										
										<div class="d-flex align-center mt-5" @click="toLink('/edu/schedule/list')" style="cursor: pointer;">
											<v-avatar rounded class="my-1">
												<v-img src="https://photo.youkeya.cn/assets/icon/teacher_schedule_icon.jpeg" width="50" height="50"></v-img>
											</v-avatar>
											<span class="ml-6">课表日历</span>
										</div>
										
										<div class="d-flex align-center mt-5" @click="toLink('/edu/class/record/detail/list')" style="cursor: pointer;">
											<v-avatar rounded class="my-1">
												<v-img src="https://photo.youkeya.cn/assets/icon/add_rate_icon.png" width="50" height="50"></v-img>
											</v-avatar>
											<span class="ml-6">点名记录</span>
										</div>
										
									</v-col>
									<v-col cols="4">
										<div class="d-flex align-center mt-1" @click="toLink('/sys/employee/list')" style="cursor: pointer;">
											<v-avatar rounded class="my-1">
												<v-img src="https://photo.youkeya.cn/assets/icon/add_teacher_icon.png" width="50" height="50"></v-img>
											</v-avatar>
											<span class="ml-6">新增老师</span>
										</div>
										<div class="d-flex align-center mt-5" @click="toLink('/sys/course/list')" style="cursor: pointer;">
											<v-avatar rounded class="my-1">
												<v-img src="https://photo.youkeya.cn/assets/icon/add_course_icon.png" width="50" height="50"></v-img>
											</v-avatar>
											<span class="ml-6">新增课程</span>
										</div>
										<div class="d-flex align-center mt-5" @click="toLink('/sys/classroom/list')" style="cursor: pointer;">
											<v-avatar rounded class="my-1">
												<v-img src="https://photo.youkeya.cn/assets/icon/add_room_icon.png" width="50" height="50"></v-img>
											</v-avatar>
											<span class="ml-6">新增教室</span>
										</div>
										<div class="d-flex align-center mt-5" @click="toLink('/edu/potential/list')" style="cursor: pointer;">
											<v-avatar rounded class="my-1">
												<v-img src="https://photo.youkeya.cn/assets/icon/potential_icon.png" width="50" height="50"></v-img>
											</v-avatar>
											<span class="ml-6">意向学员跟进</span>
										</div>
										
										
									</v-col>
									<v-col cols="4">
										<div v-if="financialAccess.courseAccount && modeEnabled('1')" class="d-flex align-center mt-1" @click="toLink('/financial/course/account/index')" style="cursor: pointer;">
											<v-avatar rounded class="my-1">
												<v-img src="https://photo.youkeya.cn/assets/icon/course_account_icon.png" width="50" height="50"></v-img>
											</v-avatar>
											<span class="ml-6">课时账户充值</span>
										</div>
										<div v-if="modeEnabled('2')" class="d-flex align-center mt-5" @click="toLink('/financial/cash/account/index')" style="cursor: pointer;">
											<v-avatar rounded class="my-1">
												<v-img src="https://photo.youkeya.cn/assets/icon/cash_account_icon.png" width="50" height="50"></v-img>
											</v-avatar>
											<span class="ml-6">金额账户充值</span>
										</div>
										
										
										<div v-if="financialAccess.tradeFlow" class="d-flex align-center mt-5" @click="toLink('/financial/trade/flow/list')" style="cursor: pointer;">
											<v-avatar rounded class="my-1">
												<v-img src="https://photo.youkeya.cn/assets/icon/financial_journal_icon.png" width="50" height="50"></v-img>
											</v-avatar>
											<span class="ml-6">收支明细</span>
										</div>
										<div class="d-flex align-center mt-5" @click="toLink('/exchange/order/list')" style="cursor: pointer;">
											<v-avatar rounded class="my-1">
												<v-img src="https://photo.youkeya.cn/assets/icon/point_order_icon.png" width="50" height="50"></v-img>
											</v-avatar>
											<span class="ml-6">积分兑换</span>
										</div>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
						<!-- 提醒 -->
						<v-card class="mt-5">
							<v-card-title>数据预警</v-card-title>
							<v-card-text class="pb-5">
								<v-row>
									<v-col cols="3" v-for="(item,index) in warnData" :key="index">
										<div class="d-flex justify-space-between pl-3 mr-5 align-center warn_item elevation-2" @click="toWarnPage(item)">
											<span style="font-size: 16px; color: black;">{{item.caption}}</span>
											<v-avatar color="#039BE5" size="25" class="mr-3">
											      <span class="white--text" style="font-size: 15px;">{{item.count}}</span>
											</v-avatar>
										</div>
									</v-col>
									
								</v-row>
								
							</v-card-text>
						</v-card>
						
						<!-- 客服信息 -->
						<v-card class="mt-5">
							<v-card-title>客服信息</v-card-title>
							<v-card-text class="pb-5">
								<v-row>
									<v-col cols="3">
										<div style="font-size:16px;color:#000">
											<span>业务咨询:</span>  
											<span>橙子 15618660303(微信同号)</span>  
										</div>
									</v-col>
									<v-col cols="3">
										<div style="font-size:16px;color:#000">
											<span>技术支持:</span>  
											<span>黄工 18616658240(微信同号)</span>  
										</div>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
						
						<!-- 绑定微信提醒 -->
						<v-card class="pa-5 d-flex mt-5 align-center">
							<div>
								<v-avatar size="40" rounded>
									<v-img src="https://photo.youkeya.cn/assets/icon/wx_logo.png"></v-img>
								</v-avatar>
							</div>
							<div class="ml-5">
								关注公众号并登录教师端,实时接收消息通知，手机端随时随地管理校区！
							</div>
							<div @click="wxQrcodeShow=true">
								<span style="color: #0277BD;cursor: pointer;">立即关注>></span>
							</div>
						</v-card>
						
					</v-col>
					
					<v-col cols="3" class="pa-2">
						<!-- 待办事项 -->
						<v-card width="500" class="mr-3 mb-4">
							<v-toolbar color="pink lighten-1" dark style="border-radius: 5px 5px 0 0;">
								<v-toolbar-title>待办事项</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-btn icon @click="getEduWaitCountList">
									<v-icon>mdi-refresh-circle</v-icon>
								</v-btn>
							</v-toolbar>
							<v-list two-line>
								<v-list-item-group >
									<template v-for="(item, index) in waitTodoCount" >
										<v-list-item :key="index" @click="waitTodoItemClicked(item)">
											<v-list-item-content>
												<v-list-item-title>
													<span style="font-weight: 400;font-size:16px;">{{item.title}}</span>
												</v-list-item-title>
											</v-list-item-content>
															
											<v-list-item-action>
												<v-list-item-action-text>
													<v-avatar color="pink lighten-1" size="30">
													      <span class="white--text" style="font-size: 16px;">{{item.count}}</span>
													</v-avatar>
												</v-list-item-action-text>
											</v-list-item-action>
										</v-list-item>
							
										<v-divider v-if="index < waitTodoCount.length-1"></v-divider>
									</template>
								</v-list-item-group>
							</v-list>
						</v-card>
						<!-- 充值pie图 -->
						
						
						<v-card class="mt-5">
							<v-card-title>本月缴费&消课收入</v-card-title>
							<v-card-text>
								<div id="pieid0" style="height: 300px;"></div>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-sheet>
			
			<!-- 右侧帮助区 -->
			<v-sheet  class="d-flex flex-column rightCol">
				
				<div style="width: 270px; height: 120px; cursor: pointer;" class="mt-4 mr-2">
					<a href="https://www.yuque.com/yundou-fu7fp/ey68az/chzomnax7p5g7qyb" target="_blank">
						<v-img src="https://photo.youkeya.cn/assets/img/op_1669036459.png" style="border-radius: 10px;"></v-img>
					</a>
				</div>

				<!-- <div class="mt-2"><v-btn @click="desc.dialog=true" color="success">系统功能介绍</v-btn></div> -->
				<div class="mt-5">
					<v-card width="270px">
						<v-card-title>操作说明</v-card-title>
						<v-card-text class="d-flex flex-column">
							<div>
								<a href="https://www.yuque.com/yundou-fu7fp/ey68az/tfl25rnl7x3ua0di" target="_blank" style="text-decoration: none;">
									1. 学员缴费充值操作说明
								</a>
							</div>
							<div class="mt-2">
								<a href="https://www.yuque.com/yundou-fu7fp/ey68az/hoext0r1ogc5fnf6" target="_blank" style="text-decoration: none;">
									2. 给学员分班操作说明
								</a>
							</div>
							<div class="mt-2">
								<a href="https://www.yuque.com/yundou-fu7fp/ey68az/aduahi3dhsemkiqb" target="_blank" style="text-decoration: none;">
									3. 核销课时操作说明
								</a>
							</div>
							<div class="mt-2">
								<a href="https://www.yuque.com/yundou-fu7fp/ey68az/aaith3zcc5pia8tn" target="_blank" style="text-decoration: none;">
									4. 积分奖励操作说明
								</a>
							</div>
						</v-card-text>
					</v-card>
				</div>
			</v-sheet>
		</v-sheet>
		
		
		<!-- 功能介绍dialog -->
		<v-dialog title="系统功能" v-model="desc.dialog" width="800px" persistent>
			<v-card>
				<v-card-title>系统功能介绍</v-card-title>
				<v-card-text>
					<iframe src="https://console.youkeya.cn/guide/yky_desc.html?v=1.0" border="0" width="760px" height="500px" frameborder="0"></iframe>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="desc.dialog=false">关闭</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<!-- 微信二维码dialog -->
		<v-dialog title="系统功能" v-model="wxQrcodeShow" width="400px" persistent>
			<v-card>
				<v-card-title>
					<span>关注“有课丫”公众号</span>
					<v-spacer></v-spacer>
					<v-icon @click="wxQrcodeShow=false">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5 d-flex justify-center">
					<div class="d-flex flex-column align-center mb-5">
						<v-avatar size="280" rounded>
							<v-img src="https://photo.youkeya.cn/assets/icon/yky_gzh_qrcode.jpeg"></v-img>
						</v-avatar>
						<span>关注后点击“教师入口”登录系统</span>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
		
		<!-- 待核销 -->
		<waitApproveBox :show="waitApproveShow" @cancel="waitApproveShow=false"></waitApproveBox>
		<!-- 待点评 -->
		<waitRateBox :show="waitRateShow" @cancel="waitRateShow=false" @updateCount="getEduWaitCountList"></waitRateBox>
		<!-- 待奖励积分 -->
		<waitGivePointBox :show="waitGivePointShow" @cancel="waitGivePointShow=false" @updateCount="getEduWaitCountList"></waitGivePointBox>
		
		<!-- 课时不足提醒组件 -->
		<courseAccountWarn :show="courseAccountWarnShow" @cancel="courseAccountWarnShow=false"></courseAccountWarn>
		<!-- 金额不足提醒组件 -->
		<cashAccountWarn :show="cashAccountWarnShow" @cancel="cashAccountWarnShow=false"></cashAccountWarn>
		<!-- 按班级点评 -->
		<recordWaitRateBox :show="recordWaitRateShow" @cancel="recordWaitRateShow=false"></recordWaitRateBox>
	</v-row>

</template>
<script>
	import {accountModes,accountModeEnabled} from '../../../config/accountModes'
	import utils from "../../../config/utils"
	import waitApproveBox from "../../../components/wait_approve_box.vue"
	import waitRateBox from "../../../components/wait_rate_box.vue"
	import waitGivePointBox from "../../../components/wait_give_point_box.vue"
	import courseAccountWarn from "../../../components/course_account_warn.vue"
	import cashAccountWarn from "../../../components/cash_account_warn.vue"
	import recordWaitRateBox from "../../../components/record_wait_rate_box.vue"
	export default {
		name: "index",
		components:{
			waitApproveBox,waitRateBox,waitGivePointBox,courseAccountWarn,cashAccountWarn,recordWaitRateBox
		},
		data() {
			return {
				dialog: false,
				shopId:"",
				createStudentShow:false, // 创建学员
				createClassShow:false, // 创建班级
				waitTodoCount:[],
				waitApproveShow:false,
				waitRateShow:false,
				waitGivePointShow:false,
				courseAccountWarnShow:false,
				cashAccountWarnShow:false,
				wxQrcodeShow:false,
				monthData:{},// 月度数据
				financialAccess: {},
 accountModes,
				warnData:[],// 数据预警
				chartData: {
					rows: [
						{'费用类型':'充值缴费','金额':100},
						{'费用类型':'消课收入','金额':100},
					],
				},
				desc:{
					dialog:false,
					url:"",
				},
				recordWaitRateShow:false,
				vchart:null
				
			}
		},
		mounted() {
			// 创建报表
			this.createOrUpdatePie();

		},
		onBeforeUnmount(){
			if (this.vchart) {
			  this.vchart.release();
			}	
		},
		created() {
			this.shopId = utils.getCurrentShopId();
			this.loadFinancialAccess();
			
			this.getEduWaitCountList();
			this.getMonthData();
			this.getWarnData();
		},
		methods: {
 modeEnabled(mode){return accountModeEnabled(mode, utils.getCurrentShopId())},
			async loadFinancialAccess() {
				this.financialAccess = {};
				try {
					const { data } = await this.axios.get('/financial/access');
					if (data.code === 200 && data.data) this.financialAccess = data.data;
				} catch (error) { /* Permission failures keep financial shortcuts hidden. */ }
			},
			createOrUpdatePie(){
				const spec = {
					type: 'pie',
					data: [
					  {
					    id: 'id0',
					    values: this.chartData.rows
					  }
					],
					outerRadius: 0.8,
					valueField: '金额',
					categoryField: '费用类型',
					title: {
					  visible: false,
					  text: '充值/消课'
					},
					color: {
					  type: "ordinal",
					  domain: [],
					  range: ['#448AFF',['#9575CD']],
					},
					label: {
					  visible: true,
					  style:{
						  text:datum=>datum['费用类型'],
					  }
					},
					legends: {
					    visible: false,
					    orient: 'left',
					},
					tooltip: {
					  mark: {
					    content: [
					      {
					        key: datum => datum['费用类型'],
					        value: datum => datum['金额'] + "元"
					      }
					    ]
					  }
					}
				};
				
				if(!this.vchart){
					this.vchart = new VChart.default(spec, { dom: 'pieid0' });
				}else{

					this.vchart.updateSpec(spec);
				}
				
				this.vchart.renderSync();	
			},
			createStudentSuccess(){
				this.createStudentShow= false;
			},
			createClassSuccess(){
				this.createClassShow = false;
			},
			toPage(item) {
				this.$router.push(item.url);
			},
			toLink(link) {
				this.$router.push(link);
			},
			toStudentList(){
				this.$router.push({
					path:'/edu/student/list',
					query:{
						isJoinClass:"0"
					}
				});
				
			},
			toClassList(maxCount){
				this.$router.push({
					path:'/edu/class/list',
					query:{
						minLessonCount:"0",
						maxLessonCount:maxCount
					}
				});
			},
			waitTodoItemClicked(item){
				if(item.dataType=="waitApprove"){
					this.waitApproveShow=true;
				}else if (item.dataType == "waitRate"){
					this.waitRateShow = true;
				}else if (item.dataType == "waitGivePoint"){
					this.waitGivePointShow = true;
				}else if (item.dataType == "waitApproveAbsence"){
					this.$router.push('/edu/absence/list');
				}else if (item.dataType == "waitRecordRate"){
					this.recordWaitRateShow = true;
				}
			},
			getEduWaitCountList(){
				const that = this;
				let url = `/edu/teacher/edu/wait/todo/count?shopId=${this.shopId}`;
				
							
				this.axios.get(url).then(response => {
							
					if (response.data["code"] === 200) {
						
						console.log(response.data);
						
						that.waitTodoCount = response.data["data"]? response.data["data"] : [];
						
						return
					}
				})
			},
			getMonthData(){
				const shopId = utils.getCurrentShopId();
				
				const that = this;
				let url = `/report/home/month/data?shopId=${shopId}`;
						
				this.axios.get(url).then(response => {
							
					if (response.data["code"] === 200) {
						
						console.log(response.data);
						
						that.monthData = response.data["data"]? response.data["data"] : [];
						
						// 饼图数据源
						that.chartData.rows = [
							{'费用类型':'充值缴费','金额':that.monthData.rechargeAmount},
							{'费用类型':'消课收入','金额':that.monthData.recordRevenueAmount},
						];
						
						that.createOrUpdatePie();
						
						return
					}
				})
			},
			getWarnData(){
				const that = this;
				let url = `/report/home/warn/data?shopId=${this.shopId}`;
						
				this.axios.get(url).then(response => {
							
					if (response.data["code"] === 200) {
						
						console.log("warndata",response.data);
						
						that.warnData = response.data["data"]? response.data["data"] : [];
						
						return
					}
				})
			},
			toWarnPage(item){
				if (item.dataType == 'noClass'){
					this.toStudentList();
				}else if (item.dataType=='recordLess'){
					this.toClassList(item.warnValue);
				}else if (item.dataType=='hoursLess'){
					this.courseAccountWarnShow =true;
				}else if (item.dataType=='cashLess'){
					this.cashAccountWarnShow =true;
				}
			}
		},

	}
</script>
<style lang="scss" scoped>
	.warn_item{
		background-color: #E1F5FE;
		border-radius: 10px;
		height: 60px;
		cursor: pointer;
		
	}
	.rightCol{
		width: 330px;
		height: 100vh;
		display: block;
	}
	
	/* 当屏幕尺寸小于1400像素时 */
	@media (max-width: 1400px) {
	  .rightCol {
	    /* 隐藏元素 */
	    display: none !important;
	  }
	}
	
</style>
